import { Paper, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ContractPaper = styled(Paper, {
    shouldForwardProp: (prop) => prop !== "isDesktop",
})<{ isDesktop: boolean }>(({ theme, isDesktop }) =>
    theme.unstable_sx({
        p: isDesktop ? { md: 5 } : undefined,
    }),
);

export const ContractErrorStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        px: { md: 0, xs: 4 },
        py: 4,
    }),
);

export const ContractContentStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        px: { md: 0, xs: 4 },
    }),
);
